module.exports = __webpack_public_path__ + "img/arrow-select.8d4183c6.svg";